export default {"src":"/_next/static/media/time_Icon.59144584.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};